/** Shared helpers for the admin affiliate earnings page. */

/** Format integer cents as dollars, e.g. 12345 -> "$123.45". */
export const formatCents = (cents: number): string => `$${(cents / 100).toFixed(2)}`;

/** Format an ISO date string as en-US short date, e.g. "Jul 16, 2026". */
export const formatShortDate = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

/** Safely extract a backend error message from an unknown RTK Query error. */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  if (typeof err === 'object' && err !== null && 'data' in err) {
    const data = (err as { data?: unknown }).data;
    if (typeof data === 'object' && data !== null && 'message' in data) {
      const message = (data as { message?: unknown }).message;
      if (typeof message === 'string' && message.trim().length > 0) {
        return message;
      }
    }
  }
  return fallback;
};
